import { useEffect, useState } from 'react'
import useErrorReporter from './useErrorReporter'

// always pass the identical requestFn and requestFnArg unless you need to refetch
export default function useFetchData(requestFn, { initialData = null, requestFnArg } = {}) {
  const reportError = useErrorReporter()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(initialData)

  useEffect(() => {
    let cancelled = false
    async function fetchData() {
      try {
        setLoading(true)
        const newData = await requestFn(requestFnArg)
        !cancelled && setData(newData)
      } catch (e) {
        !cancelled && reportError(e)
      } finally {
        !cancelled && setLoading(false)
      }
    }
    fetchData()
    return () => {
      cancelled = true
    }
  }, [reportError, requestFn, requestFnArg])

  return {
    data,
    loading,
  }
}
